import { render, staticRenderFns } from "./InhabitantChangesRequest.vue?vue&type=template&id=78f0daf4&scoped=true&"
import script from "./InhabitantChangesRequest.vue?vue&type=script&lang=js&"
export * from "./InhabitantChangesRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0daf4",
  null
  
)

export default component.exports